import { Routes, Route } from 'react-router-dom'
import { Header } from './components/Header.jsx'
import { Home } from './pages/Home.jsx'
import { Login } from './pages/Login.jsx'
import { Signup } from './pages/Signup.jsx'
import { ParticipantsPage } from './pages/Participants.jsx'
import { ParticipantFormPage } from './pages/ParticipantForm.jsx'
import { AccountProfilePage } from './pages/AccountProfile.jsx'
import { CoursesPage } from './pages/Courses.jsx'
import { CourseDetailPage } from './pages/CourseDetail.jsx'
import { MyEnrollmentsPage } from './pages/MyEnrollments.jsx'
import { PrepayPage } from './pages/Prepay.jsx'
import { PaymentSuccessPage } from './pages/PaymentSuccess.jsx'
import { PaymentCancelPage } from './pages/PaymentCancel.jsx'
import { AdminPage } from './pages/Admin.jsx'
import { AdminUsersPage } from './pages/AdminUsers.jsx'
import { AdminUserFormPage } from './pages/AdminUserForm.jsx'
import { AdminUserDetailPage } from './pages/AdminUserDetail.jsx'
import { AdminParticipantFormPage } from './pages/AdminParticipantForm.jsx'
import { AdminCategoriesPage } from './pages/AdminCategories.jsx'
import { AdminCategoryFormPage } from './pages/AdminCategoryForm.jsx'
import { AdminDiscountsPage } from './pages/AdminDiscounts.jsx'
import { AdminDiscountFormPage } from './pages/AdminDiscountForm.jsx'
import { AdminDiscountLogPage } from './pages/AdminDiscountLog.jsx'
import { AdminAnnouncementsPage } from './pages/AdminAnnouncements.jsx'
import { AdminAnnouncementFormPage } from './pages/AdminAnnouncementForm.jsx'
import { AdminCoursesPage } from './pages/AdminCourses.jsx'
import { AdminCourseFormPage } from './pages/AdminCourseForm.jsx'
import { AdminCourseParticipantsPage } from './pages/AdminCourseParticipants.jsx'
import { AdminWaitlistPage } from './pages/AdminWaitlist.jsx'
import { AdminBillingPage } from './pages/AdminBilling.jsx'
import { AdminPrepayPage } from './pages/AdminPrepay.jsx'
import { AdminPaymentsPage } from './pages/AdminPayments.jsx'
import { AdminPresencesPage } from './pages/AdminPresences.jsx'
import { AdminOrganizationPage } from './pages/AdminOrganization.jsx'
import { TeacherCoursesPage } from './pages/TeacherCourses.jsx'
import { TeacherCourseDetailPage } from './pages/TeacherCourseDetail.jsx'
import { TeacherAttendancePage } from './pages/TeacherAttendance.jsx'
import { TeacherAttendanceByDatePage } from './pages/TeacherAttendanceByDate.jsx'

export default function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/"                       element={<Home />} />
        <Route path="/login"                  element={<Login />} />
        <Route path="/signup"                 element={<Signup />} />
        <Route path="/settings/profile"       element={<AccountProfilePage />} />
        <Route path="/settings/participants"           element={<ParticipantsPage />} />
        <Route path="/settings/participants/new"       element={<ParticipantFormPage />} />
        <Route path="/settings/participants/:id/edit"  element={<ParticipantFormPage />} />

        <Route path="/courses"                element={<CoursesPage />} />
        <Route path="/courses/:slug"          element={<CourseDetailPage />} />
        <Route path="/me/enrollments"         element={<MyEnrollmentsPage />} />
        {/* Monthly prepay offer — the link in the offer notification carries
            the month; without it the current month is used. */}
        <Route path="/prepay"                 element={<PrepayPage />} />
        <Route path="/prepay/:month"          element={<PrepayPage />} />
        <Route path="/payments/success"       element={<PaymentSuccessPage />} />
        <Route path="/payments/cancel"        element={<PaymentCancelPage />} />

        <Route path="/teacher"                        element={<TeacherCoursesPage />} />
        <Route path="/teacher/courses/:id"            element={<TeacherCourseDetailPage />} />
        <Route path="/teacher/courses/:id/attendance" element={<TeacherAttendancePage />} />
        <Route path="/teacher/attendance"             element={<TeacherAttendanceByDatePage />} />

        <Route path="/admin"                     element={<AdminPage />} />
        <Route path="/admin/users"               element={<AdminUsersPage />} />
        <Route path="/admin/users/new"           element={<AdminUserFormPage />} />
        <Route path="/admin/users/:id"           element={<AdminUserDetailPage />} />
        <Route path="/admin/users/:id/edit"      element={<AdminUserFormPage />} />
        <Route path="/admin/users/:uid/participants/new"       element={<AdminParticipantFormPage />} />
        <Route path="/admin/users/:uid/participants/:pid/edit" element={<AdminParticipantFormPage />} />
        <Route path="/admin/categories"          element={<AdminCategoriesPage />} />
        <Route path="/admin/categories/new"      element={<AdminCategoryFormPage />} />
        <Route path="/admin/categories/:id/edit" element={<AdminCategoryFormPage />} />
        <Route path="/admin/discounts"           element={<AdminDiscountsPage />} />
        <Route path="/admin/discounts/log"       element={<AdminDiscountLogPage />} />
        <Route path="/admin/discounts/new"       element={<AdminDiscountFormPage />} />
        <Route path="/admin/discounts/:id/edit"  element={<AdminDiscountFormPage />} />
        {/* Announcements are ONE-SHOT — there is a "new" route and no edit
            route, because an announcement already in people's inboxes cannot
            honestly be changed afterwards. */}
        <Route path="/admin/announcements"       element={<AdminAnnouncementsPage />} />
        <Route path="/admin/announcements/new"   element={<AdminAnnouncementFormPage />} />
        <Route path="/admin/courses"             element={<AdminCoursesPage />} />
        <Route path="/admin/courses/new"         element={<AdminCourseFormPage />} />
        <Route path="/admin/courses/:id/edit"    element={<AdminCourseFormPage />} />
        <Route path="/admin/courses/:id/participants" element={<AdminCourseParticipantsPage />} />
        <Route path="/admin/waitlist"            element={<AdminWaitlistPage />} />
        <Route path="/admin/billing"             element={<AdminBillingPage />} />
        <Route path="/admin/prepay"              element={<AdminPrepayPage />} />
        <Route path="/admin/payments"            element={<AdminPaymentsPage />} />
        <Route path="/admin/presences"           element={<AdminPresencesPage />} />
        <Route path="/admin/organization"        element={<AdminOrganizationPage />} />

        <Route path="*"                       element={<Home />} />
      </Routes>
    </>
  )
}
